import { PriceComponentsBracket } from './price-components-bracket';

export class ProductPriceComponentsBracket {
  productId: number;
  brackets: Array<PriceComponentsBracket>;
}
